import React, { Component } from "react";
import PropTypes from "prop-types";
import Dropdown, { DropdownItem } from "~/components/Dropdown/Dropdown";
import styles from "./LanguagesDropdown.scss";
import { executeEvent } from "../../utils/misc";
import constants from "../../utils/constants";

class LanguagesDropdown extends Component {
  constructor(props) {
    super(props);

    // Binding
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  handleOnChange(value) {
    this.props.onLanguageChange(value);

    window.wbkLanguage = value;

    executeEvent(constants.EVENTS.CHANGED_LANGUAGE);
  }

  render() {
    return (
      <Dropdown
        value={this.props.value}
        onChange={this.handleOnChange}
        className={styles.languagesDropdown}
        isLanguage
        //FIXME: This does nothing
        // isMobile={this.props.isMobile}
        label={this.props.label}
        placement={this.props.placement}
        CustomArrowDown={this.props.CustomArrowDown}>
        {this.props.languages &&
          this.props.languages.map(item => (
            <DropdownItem key={item} value={item}>
              <span className={styles.flag + " " + styles[item]} alt={item} />
              {item}
            </DropdownItem>
          ))}
      </Dropdown>
    );
  }
}

export default LanguagesDropdown;

LanguagesDropdown.propTypes = {
  languages: PropTypes.object.isRequired,
  onLanguageChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string,
  isMobile: PropTypes.bool,
  placement: PropTypes.string,
  CustomArrowDown: PropTypes.object,
};
